import { GridCellProps } from '@progress/kendo-react-grid';
import { splitNumberLookup } from 'admin/pages/ReportsPage/static';
import { AdminCheckBox } from 'app/components/AdminCheckbox';
import AdminDropDown from 'app/components/AdminDropDown';
import { SHToolTip } from 'app/components/SHToolTip';
import React from 'react';
import { GeneralLookup } from 'services/openapi';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
  onViewClick?: (e) => void;
  onClassASplitNumberDataChange: (e: any, event: any, className: any) => void;
  classASplitNumber: { [key: string]: GeneralLookup };
  setClassASplitNumber: React.Dispatch<
    React.SetStateAction<{ [key: string]: GeneralLookup }>
  >;
  classBSplitNumber: { [key: string]: GeneralLookup };
  setClassBSplitNumber: React.Dispatch<
    React.SetStateAction<{ [key: string]: GeneralLookup }>
  >;
  onClassAChange: (e: any, event: any, className: any) => void;
  classAChecked: {
    [key: string]: boolean;
  };
  setClassAChecked: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
  classBChecked: {
    [key: string]: boolean;
  };
  setClassBChecked: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
  isRiderSelected: boolean;
};

const RiderClassUpdateCell = ({
  e,
  onViewClick,
  onClassASplitNumberDataChange,
  setClassASplitNumber,
  classASplitNumber,
  onClassAChange,
  classAChecked,
  setClassAChecked,
  isRiderSelected,
}: Props) => {
  const data = e.dataItem;
  return (
    <StyledTd
      style={e.style}
      className={e.className}
      onClick={() => onViewClick?.(data)}
    >
      <CustomTableColumnWrapper>
        {e.dataItem.class?.map((item, index) => {
          const riderId = data.id;
          const compositeKey = `${riderId}_${item.riderClass.id}`;

          return (
            <SplitWrapper className="SplitWrapper" key={index}>
              <div className="admin-checkbox-style">
                <SHToolTip position="top">
                  <AdminCheckBox
                    onChange={event => {
                      setClassAChecked(prev => ({
                        ...prev,
                        [compositeKey]: event.value, // Use composite key
                      }));
                      if (!event.value) {
                        setClassASplitNumber(prev => ({
                          ...prev,
                          [compositeKey]: {} as GeneralLookup,
                        }));
                      }
                      onClassAChange(e, event, item.riderClass);
                    }}
                    value={classAChecked[compositeKey] || false} // Use composite key
                    label={item.riderClass.name}
                    className="checkbox-style"
                    title={item.riderClass.name}
                    isDisabled={!isRiderSelected}
                  />
                </SHToolTip>
              </div>
              <AdminDropDown
                label=""
                onDataChange={event => {
                  if (event) {
                    setClassASplitNumber(prev => ({
                      ...prev,
                      [compositeKey]: event, // Use composite key
                    }));
                    onClassASplitNumberDataChange(e, event, item.riderClass);
                  }
                }}
                defaultValue={classASplitNumber[compositeKey] || ''}
                placeholder="Choose Split Number"
                data={splitNumberLookup}
                className="field-style"
                disabled={!classAChecked[compositeKey]} // Use composite key
              />
            </SplitWrapper>
          );
        })}
      </CustomTableColumnWrapper>
    </StyledTd>
  );
};

export default RiderClassUpdateCell;
const StyledTd = styled.td``;
const CustomTableColumnWrapper = styled.div`
  width: 100%;
  .SHdropdown {
    width: 60%;
    .k-dropdownlist {
      max-height: 31px;
      width: 200px;
      border-radius: 8px !important;
      font-size: 13px;
      .k-input-value-text {
        font-size: 13px;
        font-family: 'Inter';
        cursor: pointer;
        font-weight: 500;
        line-height: 19.6px;
      }
    }
  }
  .srv-validation-message {
    color: #f44336;
    font-size: 12px;
    display: inline-block;
  }
`;
const SplitWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 20px;
  .checkbox-style {
    label {
      width: 175px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;
